import { render, staticRenderFns } from "./authCode.vue?vue&type=template&id=5aa7a7c5&"
import script from "./authCode.vue?vue&type=script&lang=js&"
export * from "./authCode.vue?vue&type=script&lang=js&"
import style0 from "./authCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports